import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useConsumptionReference } from "src/api/sure-api/useConsumptionReference";

type ConsumptionProps = {
    productConsumptions: {
        consumptionReferenceId: number;
        consumptionCode?: string | null;
        consumptionNameFr?: string | null;
    }[];
};
export const ProductConsumptionSummary = (props: ConsumptionProps) => {
    const { productConsumptions } = props;
    const { t } = useTranslation();

    const { consumptionReference } = useConsumptionReference();

    if (productConsumptions.length === 0) {
        return (
            <Typography
                variant="h3"
                sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                }}
            >
                {t("product.consumption.no_mode_associated", "No use methods associated to this product")}
            </Typography>
        );
    }
    const noValue = "-";
    return (
        <Box>
            <Typography variant="h4">{t("product.consumption.mode_label", "Product use method:")}</Typography>
            <ul>
                {productConsumptions.map((productConsumption) => {
                    const foundConsumption = consumptionReference?.find(
                        (consumption) => consumption.id === productConsumption.consumptionReferenceId,
                    );
                    const label =
                        foundConsumption?.label ??
                        productConsumption.consumptionNameFr ??
                        productConsumption.consumptionCode ??
                        noValue;
                    return (
                        <li key={productConsumption.consumptionReferenceId}>
                            <Typography variant="body">{label}</Typography>
                        </li>
                    );
                })}
            </ul>
        </Box>
    );
};
